import React, { useRef } from "react";
import html2canvas from "html2canvas";
import { jsPDF } from "jspdf";
import { QRCodeTemplate } from "components/QrCodeTemplate/QrCodeTemplate";
import "components/QrCodeTemplate/QrCodeTemplate.scss";

export function QrCodeDownload() {
  const qrContainerRef = useRef(null);

  const downloadQRCode = async () => {
    const qrContainerElement = qrContainerRef.current;
    if (!qrContainerElement) return;

    const canvas = await html2canvas(qrContainerElement, {
      useCORS: true,
      scale: 2, // Adjust the scale value for higher resolution
    });

    const imageData = canvas
      .toDataURL("image/png")
      .replace("image/png", "image/octet-stream");

    const pdf = new jsPDF("p", "mm", "a4");
    pdf.addImage(imageData, "PNG", 10, 10, 190, 277); // Adjust the dimensions to fit A4 size
    pdf.save("BookDocQrCode.pdf");
  };

  return (
    <div className="p-3">
      <div ref={qrContainerRef}>
        <QRCodeTemplate />
      </div>
      <button onClick={downloadQRCode}>Download</button>
    </div>
  );
}
